
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/operations.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/operations.md?type=demo')
};